var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { MODOS, getCPFFormatado, getDataFormatada } from '../../../utils';
import GridBase from '../../../components/grid_base';
import { FiltrosVagas } from '../components/FiltrosVagas';
import { BotoesExportacao } from '../../../components/botoes_exportacao';
import { getContratosTrabalho, getCombosListarContratos, gerarExcelContratos, gerarPDFContratos } from './contratos_trabalho.service';
export var ContratosTrabalhoListar = function () {
    var navigate = useNavigate();
    var isContrato = function (row) { return row.tipo_registro !== 'VAGA'; };
    var colunas = useMemo(function () { return [
        {
            field: 'nome',
            headerName: 'Nome',
            width: 250,
            valueGetter: function (_value, row) { var _a, _b, _c; return (_b = (_a = row.reeducando) === null || _a === void 0 ? void 0 : _a.nome) !== null && _b !== void 0 ? _b : (_c = row.vaga) === null || _c === void 0 ? void 0 : _c.descricao; },
        },
        {
            field: 'cpf',
            headerName: 'CPF',
            width: 150,
            valueGetter: function (_value, row) { var _a; return getCPFFormatado((_a = row.reeducando) === null || _a === void 0 ? void 0 : _a.cpf); },
        },
        {
            field: 'regime',
            headerName: 'Regime de Pena',
            width: 150,
            valueGetter: function (_value, row) { var _a, _b, _c, _d, _e; return (_c = (_b = (_a = row.reeducando) === null || _a === void 0 ? void 0 : _a.regime_reclusao_atual) === null || _b === void 0 ? void 0 : _b.nome) !== null && _c !== void 0 ? _c : (_e = (_d = row.vaga) === null || _d === void 0 ? void 0 : _d.regime_reclusao_atual) === null || _e === void 0 ? void 0 : _e.nome; },
        },
        {
            field: 'instituicao',
            headerName: 'Instituição',
            width: 250,
            valueGetter: function (_value, row) { var _a, _b; return (_b = (_a = row.instituicao) === null || _a === void 0 ? void 0 : _a.dados) === null || _b === void 0 ? void 0 : _b.razao_social; },
        },
        {
            field: 'data_inicio',
            headerName: 'Data de Início',
            width: 150,
            valueGetter: function (_value, row) { return getDataFormatada(row.data_inicio); },
        },
        { field: 'status', headerName: 'Status', width: 150 },
        {
            field: 'Opções',
            headerName: '',
            align: 'right',
            flex: 1,
            minWidth: 100,
            renderCell: function (params) { return (_jsxs(Box, __assign({ flex: 1, display: 'flex', justifyContent: 'flex-end' }, { children: [isContrato(params.row) && (_jsx(Tooltip, __assign({ title: 'Visualizar', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ bgcolor: 'primary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 1, marginTop: -1 }, onClick: function () { return navigate("".concat(ROUTES.CONTRATOS_TRABALHO, "/").concat(params.row.id, "/").concat(MODOS.VISUALIZAR)); } }, { children: _jsx(VisibilityOutlinedIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })) }))), isContrato(params.row) && params.row.status !== 'ENCERRADO' && (_jsx(Tooltip, __assign({ title: 'Encerrar Contrato', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ bgcolor: 'secondary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 1, marginTop: -1 }, onClick: function () { return navigate("".concat(ROUTES.CONTRATOS_TRABALHO, "/").concat(params.row.id, "/").concat(MODOS.ALTERAR)); } }, { children: _jsx(LogoutIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })) })))] }))); },
        },
    ]; }, [navigate]);
    return (_jsx(GridBase, { pagina: PAGINAS.CONTRATOS_TRABALHO, paginaPermissao: FUNCIONALIDADES.CONTRATOS_TRABALHO, rota: ROUTES.CONTRATOS_TRABALHO, columns: colunas, hideAddButton: true, 
        // Anula coluna padrão para utilizar a coluna "Opções" personalizada criada nas colunas acima
        botoesAcoesCustomizados: function () { return null; }, 
        // Injeta os botões de PDF e Excel na barra superior
        botoesSuperiorExtras: function (estadoBusca, acoesPermitidas) { return (_jsx(BotoesExportacao, { estadoBusca: estadoBusca, acoesPermitidas: acoesPermitidas, gerarPDF: gerarPDFContratos, gerarExcel: gerarExcelContratos })); }, filtrosIniciais: {
            status: '-1',
            instituicao: -1,
            dataInicio: '',
            dataFim: '',
        }, fetchData: function (textoBusca, filtros, paginationModel) {
            var _a;
            return getContratosTrabalho(textoBusca === '' ? null : textoBusca, filtros.status === '-1' ? null : filtros.status, filtros.instituicao === -1 ? null : (_a = filtros.instituicao) === null || _a === void 0 ? void 0 : _a.toString(), filtros.dataInicio === '' ? null : filtros.dataInicio, filtros.dataFim === '' ? null : filtros.dataFim, paginationModel);
        }, renderFiltros: function (filtros, atualizarFiltros) { return (_jsx(FiltrosVagas, { filtrosAtuais: filtros, atualizarFiltros: atualizarFiltros, getCombosListar: getCombosListarContratos })); } }));
};
export default ContratosTrabalhoListar;
